import React from 'react';
import { Spin } from 'antd';

const ViewLoading = () => {
  return(
    <div
      style={{ 
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        background: '#fff',
      }}
    >
      <Spin tip="Cargando..." size="large" />
    </div>
  );
};

export default ViewLoading;